import { render, staticRenderFns } from "./SsoForbidden.vue?vue&type=template&id=7da8e8f2&"
import script from "./SsoForbidden.vue?vue&type=script&lang=ts&"
export * from "./SsoForbidden.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports